import { render } from "./App.vue?vue&type=template&id=84e80d0c"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=84e80d0c&lang=css"

import exportComponent from "D:\\work\\luwei_work\\mine_demo\\vue_three_demo\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__